var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports-(no-template-selected)",
    transform: "translate(-1078.000000, -236.000000)",
    fill: "#CCD6F6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1078.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7142857,8.69386873 L9.42857143,8.69386873 L9.42857143,7.31760039 C9.42857143,7.14292017 9.28392857,7 9.10714286,7 L8.03571429,7 C7.85892857,7 7.71428571,7.14292017 7.71428571,7.31760039 L7.71428571,8.69386873 L4.28571429,8.69386873 L4.28571429,7.31760039 C4.28571429,7.14292017 4.14107143,7 3.96428571,7 L2.89285714,7 C2.71607143,7 2.57142857,7.14292017 2.57142857,7.31760039 L2.57142857,8.69386873 L1.28571429,8.69386873 C0.575892857,8.69386873 0,9.26290275 0,9.96427027 L0,19.2805483 C0,19.9819158 0.575892857,20.5509498 1.28571429,20.5509498 L10.7142857,20.5509498 C11.4241071,20.5509498 12,19.9819158 12,19.2805483 L12,9.96427027 C12,9.26290275 11.4241071,8.69386873 10.7142857,8.69386873 Z M10.5535714,19.2805483 L1.44642857,19.2805483 C1.35803571,19.2805483 1.28571429,19.2090882 1.28571429,19.1217481 L1.28571429,11.2346718 L10.7142857,11.2346718 L10.7142857,19.1217481 C10.7142857,19.2090882 10.6419643,19.2805483 10.5535714,19.2805483 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2446760614300bbd2767db3fb4b56623.svg";
export { ForwardRef as ReactComponent };